<template>
    <div class="img_file_wrapper">
        <form class="dropzone needsclick imgfile" id="img-files" action="/upload" style="max-height : 243px;">
            <div class="profile_thumbnail" v-if="detailDropzone != null">
                <a href="javascript:void(0);" title="">
                    <div class="thumbnail_img">
                        <img v-bind:src="detailDropzone.url" alt="첨부파일 미리보기 이미지" style="width:200px; height:213px;">
                    </div>
                    <span class="thumbnail_tit">{{detailDropzone.name}}</span>
                </a>
                <button type="button" class="btn btn_del"  style="color:white;">삭제</button>
            </div> 
         
        </form>	  
    </div>
</template>



<script>
import Axios from 'axios'
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";
Dropzone.autoDiscover = false;

export default{
    data: function () {
      return {
        //   basicStyle:{'float': 'left'},
        //   isBasicStyle:false,
          dropzoneimg:null,
          detailDropzone:null,
          listDropzone:[],
          uidCode : '',
          text: '이미지 파일을 드래그 해 주세요',
          cnt : 0
      }
    }
    , props:['detailimgfile']
    , model:{
          prop:'detailImgFile'
        , event : 'listImgDrop'
    }
  
    , created: function () {
       
    }
    , watch:{
        text:function(val){
            let _cnt = this.listDropzone.length;
            return (_cnt > 0) ? _cnt + "개의 이미지파일이 있습니다." : "이미지 파일을 드래그 해 주세요."
        }
    }
    , mounted: function () {
        let vm = this;
        vm.detailDropzone = (vm.detailimgfile.url != null) ? vm.detailimgfile : {url : '/design/common/images/sub/img_profile_example01.jpg', name : '', upload: '', type: '' };
        vm.dropzoneimg = new Dropzone('#img-files', {
            
                /* previewTemplate: document.querySelector('#preview-template').innerHTML, */
                parallelUploads: 1,
                thumbnailHeight: 243,
                thumbnailWidth: 210,
                uploadMultiple: true,
                maxFiles: 1,
                maxFilesize: 17180968,
                filesizeBase: 17180968,
                dictDefaultMessage :'',
               
                init:function(){
                    let _dropzone = this;
                },
                accept:function(file, url){
                    
                     let _form = new FormData();
                     
                     _form.append('uploadFiles', file);
                     _form.append('paramText', "NONECODE");
                     _form.append('resultData', 1);

                     Axios.post("/api/profile/upload", _form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function(response) {

                    }).catch(function(ex) {
                         console.log(ex);
                    });                
                }, 
                thumbnail:function(files, dataURL){
                     let _detail = {};
                     _detail = (files.url == null ) ?  {url : '/design/common/images/sub/img_profile_example01.jpg', name : files.name, upload:files.upload, type:files.type} :  {url : dataURL, name : files.name, upload:files.upload, type:files.type} ;
                     vm.detailDropzone = _detail;
                     files.previewElement = '';
                     $('.dz-preview.dz-file-preview').eq(0).addClass("file_" + 1);
                     $('.dz-preview.dz-file-preview').css("margin", "3px");
                     $('.dz-preview.dz-file-preview').empty();
                          
                     vm.$emit('listImgDrop', vm.detailDropzone);
                }
                , removedfile:function(file){
                }
                ,acceptedFiles:"image/*" // drop 가능한 파일
          });
       
    }
    , methods: {
          fnOnClickRemoveFile:function(file){
                  let _item = vm.detailDropzone
                  if(_item.name == file.name){
                      $('.dz-preview.dz-file-preview' + ".file_" + 1).eq(0).remove();
                      this.listDropzone.splice(i, 1);
                      this.fnOnDeleteFile(file.name, _cnt, i);
                  }

          }
          , fnOnDeleteFile:function(item, cnt, txt){
               let vm = this;
               let _form = new FormData();
              _form.append('paramUid', "NONECODE");
              _form.append('paramText', item);
              _form.append('resultData', cnt);
               Axios.post("/api/img/delete", _form, { headers: { 'Content-Type': 'multipart/form-data' }
               }).then(function(response) {

               }).catch(function(ex) {
                     console.log(ex);
               });    
          }

    }
  }
</script>